
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2UZkz", function(module, exports) {

$parcel$export(module.exports, "InlineComment", () => $f4f7ab8b4171ff8f$export$183403b138e102b9);

var $diswb = parcelRequire("diswb");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $inPa6 = parcelRequire("inPa6");

var $21K7m = parcelRequire("21K7m");

var $cdbMf = parcelRequire("cdbMf");

var $7EEGh = parcelRequire("7EEGh");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $bSvtO = parcelRequire("bSvtO");
var $9jl6v = parcelRequire("9jl6v");

var $dANtQ = parcelRequire("dANtQ");
var $9QIM2 = parcelRequire("9QIM2");

var $g1WP0 = parcelRequire("g1WP0");

var $eA7s6 = parcelRequire("eA7s6");
var $3Xfi8 = parcelRequire("3Xfi8");

var $bQm3c = parcelRequire("bQm3c");

var $aSsfA = parcelRequire("aSsfA");

var $ICFae = parcelRequire("ICFae");

var $dIouf = parcelRequire("dIouf");

var $24amZ = parcelRequire("24amZ");

var $gfqXk = parcelRequire("gfqXk");
var $gczDe = parcelRequire("gczDe");

var $cZa7r = parcelRequire("cZa7r");

var $b8XTE = parcelRequire("b8XTE");

var $i6UMJ = parcelRequire("i6UMJ");
var $3mVfX = parcelRequire("3mVfX");

var $irVI7 = parcelRequire("irVI7");
var $1kHsc = parcelRequire("1kHsc");
var $4EKKB = parcelRequire("4EKKB");
var $8Ss4E = parcelRequire("8Ss4E");

var $ep3mz = parcelRequire("ep3mz");

var $aGjYc = parcelRequire("aGjYc");
var $hXzKU = parcelRequire("hXzKU");
var $liGyh = parcelRequire("liGyh");

var $1C8XP = parcelRequire("1C8XP");
var $afGoD = parcelRequire("afGoD");
var $8z9UY = parcelRequire("8z9UY");
var $bZhP7 = parcelRequire("bZhP7");
var $6Ebso = parcelRequire("6Ebso");
var $2Ntx6 = parcelRequire("2Ntx6");
var $3B9cR = parcelRequire("3B9cR");
var $dhKx6 = parcelRequire("dhKx6");

var $8wupW = parcelRequire("8wupW");
var $daq5m = parcelRequire("daq5m");
var $kEmgx = parcelRequire("kEmgx");
var $auGhu = parcelRequire("auGhu");
var $c7FK0 = parcelRequire("c7FK0");
var $9EgR7 = parcelRequire("9EgR7");

var $9wGTI = parcelRequire("9wGTI");

var $asNlu = parcelRequire("asNlu");
var $isdzP = parcelRequire("isdzP");
var $g0DaR = parcelRequire("g0DaR");
var $8dA1U = parcelRequire("8dA1U");

var $666Tc = parcelRequire("666Tc");

var $9CnRS = parcelRequire("9CnRS");

var $aMfLn = parcelRequire("aMfLn");
var $aHcFH = parcelRequire("aHcFH");

var $k8e76 = parcelRequire("k8e76");

var $dEBDF = parcelRequire("dEBDF");

var $3jwuS = parcelRequire("3jwuS");

var $7W8i8 = parcelRequire("7W8i8");

var $2qqNV = parcelRequire("2qqNV");
var $kmw3a = parcelRequire("kmw3a");

var $cAdj8 = parcelRequire("cAdj8");

var $8i27m = parcelRequire("8i27m");
var $3ZsvI = parcelRequire("3ZsvI");

var $hl0fg = parcelRequire("hl0fg");

var $7Sm4c = parcelRequire("7Sm4c");

var $en1dX = parcelRequire("en1dX");

var $7aRa9 = parcelRequire("7aRa9");

var $4Svbr = parcelRequire("4Svbr");
var $7qvmT = parcelRequire("7qvmT");

var $a3q17 = parcelRequire("a3q17");

var $bEwJH = parcelRequire("bEwJH");

var $B3Avz = parcelRequire("B3Avz");
const $f4f7ab8b4171ff8f$var$scrollableCommentSidebarStyles = (0, $ecnYn.xcss)({
    overflowY: 'scroll'
});
const $f4f7ab8b4171ff8f$var$i18n = (0, $2nPZH.defineMessages)({
    cannotDeleteTitle: {
        id: "annotation-provider-inline-comments.could.not.delete.title",
        defaultMessage: "Unable to delete comment"
    },
    commentLoadError: {
        id: "annotation-provider-inline-comments.error.comment.load.message",
        defaultMessage: "Something went wrong when loading this comment. Refresh to view the latest updates."
    },
    commentLoadErrorTitle: {
        id: "annotation-provider-inline-comments.error.comment.load.title",
        defaultMessage: "Unable to load comment"
    }
});
const $f4f7ab8b4171ff8f$var$logger = (0, $7W8i8.getLogger)('annotation-provider-inline-comment');
const $f4f7ab8b4171ff8f$var$InlineCommentComponent = ({ annotation: selectedAnnotation, onResolve: onResolve, deleteOptions: deleteOptions, onClose: onClose, isEditor: isEditor, isArchived: isArchived, onNavigationClick: onNavigationClick, onDelete: onDelete, supportedTopLevelActions: supportedTopLevelActions, getInlineNodeTypes: getInlineNodeTypes, isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar, inlineCommentRef: inlineCommentRef = ()=>{}, isInlineCommentVisible: isInlineCommentVisible = false, flags: flags, isOffline: isOffline })=>{
    const pageClass = (0, $9QIM2.usePageClass)();
    const lastSelected = (0, $gwFzn.useRef)(undefined);
    const { replyToCommentUser: replyToCommentUser } = (0, $3mVfX.useCommentsPanelState)();
    const { setReplyToCommentId: setReplyToCommentId } = (0, $3mVfX.useCommentsPanelActions)();
    if (lastSelected.current !== selectedAnnotation.id) {
        (0, $4EKKB.selectInlineCommentCompoundExperience).showComment.start({
            pageClass: pageClass,
            annotationId: selectedAnnotation.id,
            entryPoint: 'unknown:InlineComment'
        });
        lastSelected.current = selectedAnnotation.id;
    }
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const annotationElementRef = (0, $gwFzn.useRef)(null);
    const resolveWindowCloseTimeout = (0, $gwFzn.useRef)();
    const sidebarEl = (0, $gwFzn.useRef)(null);
    const commentContainerElementRef = (0, $gwFzn.useRef)(null);
    const [eventEmitter] = (0, $gwFzn.useState)(()=>isEditor ? (0, $gfqXk.getEditorAnnotationEventEmitter)() : (0, $gczDe.getRendererAnnotationEventEmitter)());
    const [shouldFocusNewReply, setShouldFocusNewReply] = (0, $gwFzn.useState)(false);
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [contentId] = (0, $ep3mz.usePageContentId)();
    // @ts-ignore FIXME: `contentId` can be `undefined` here, and needs proper handling
    const pageId = contentId;
    const { addUnresolvedInlineComment: addUnresolvedInlineComment, removeUnresolvedInlineComment: removeUnresolvedInlineComment } = (0, $k8e76.useInlineCommentsActions)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(pageId);
    const { handleClose: handleClose, setEditorCreateProps: setEditorCreateProps, setHoverProps: setHoverProps, setSelectionProps: setSelectionProps } = (0, $cZa7r.useAnnotationsDispatch)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { userId: currentUserId } = (0, $bQm3c.useSessionData)();
    const { focusedCommentId: focusedCommentId, replyToCommentId: replyToCommentId, editCommentId: editCommentQueryId } = (0, $liGyh.useInlineCommentQueryParams)();
    const { width: windowWidth } = (0, $hl0fg.useWindowSize)();
    const [editCommentId, setCommentForEdit] = (0, $gwFzn.useState)('');
    const [resolvedComment, setResolvedComment] = (0, $gwFzn.useState)(null);
    const [shouldRender, setShouldRender] = (0, $gwFzn.useState)(false);
    const [isReplyChainCollapsed, setIsReplyChainCollapsed] = (0, $gwFzn.useState)(true);
    const { onChange: onChange, resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { setActiveHighlight: setActiveHighlight } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const nudgeRef = (0, $gwFzn.useRef)(null);
    const { isSticky: isSticky } = (0, $3Xfi8.useShouldCommentSidebarBeSticky)({
        annotationElement: annotationElementRef.current,
        isEditor: !!isEditor
    });
    const sidebarOffset = (0, $eA7s6.useCommentSidebarOffset)({
        isEditor: isEditor || false,
        annotationElement: document.getElementById(selectedAnnotation.id),
        isViewCommentMode: true,
        windowWidth: windowWidth,
        isSticky: isSticky
    });
    const apolloCacheCallback = (0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment') ? (0, $g0DaR.updateApolloCacheCallbackForGA) : (0, $g0DaR.updateApolloCacheCallback);
    const RENDER_METRIC = isEditor ? (0, $a3q17.EDITOR_INLINE_COMMENT_RENDER_METRIC) : (0, $a3q17.RENDERER_INLINE_COMMENT_RENDER_METRIC);
    const handleCloseCreateComment = (0, $gwFzn.useCallback)(()=>{
        handleClose();
        setHoverProps(null);
        setSelectionProps(null);
        setEditorCreateProps(null);
    }, [
        handleClose,
        setHoverProps,
        setSelectionProps,
        setEditorCreateProps
    ]);
    const handleGqlError = (error)=>{
        // If the error is reactions based, just set it to null and move on
        if (error.message.search(/reactions/i) !== -1 || error.message.search(/cc-pages/i) !== -1) (0, $7Sm4c.markErrorAsHandled)(error);
        else experienceTracker.stopOnError({
            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
            error: error
        });
        if ((0, $9wGTI.fg)('confluence_frontend_inline_comment_load_error_flag')) {
            const parsedError = (0, $isdzP.parseError)(error);
            const translatedError = (0, $isdzP.getTranslatedError)(parsedError.message);
            if (translatedError === (0, $9CnRS.i18n).unexpectedError) flags.showWarningFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $f4f7ab8b4171ff8f$var$i18n.commentLoadErrorTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $f4f7ab8b4171ff8f$var$i18n.commentLoadError)
            });
            else flags.showWarningFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $f4f7ab8b4171ff8f$var$i18n.commentLoadErrorTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), translatedError)
            });
        }
        if ((0, $9wGTI.fg)('confluence_frontend_create_to_view_transition')) // Close the create comment component if there was an error loading the newly created comment
        handleCloseCreateComment();
    };
    const [{ readCommentsListState: readCommentsListState }] = (0, $ICFae.useUnreadComments)();
    const { data: data, loading: loading, refetch: refetch } = (0, $diswb.useQuery)((0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment') ? (0, $1C8XP.ActiveInlineCommentsQuery) : (0, $3B9cR.InlineCommentQuery), {
        variables: (0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment') ? {
            pageId: pageId,
            inlineMarkerRefList: [
                selectedAnnotation.id
            ],
            contentStatus: [
                isArchived ? 'ARCHIVED' : 'DRAFT',
                'CURRENT'
            ]
        } : {
            pageId: pageId,
            annotationId: selectedAnnotation.id,
            contentStatus: [
                isArchived ? 'ARCHIVED' : 'DRAFT',
                'CURRENT'
            ]
        },
        onError: handleGqlError,
        fetchPolicy: 'cache-and-network'
    });
    const { pageInfo: pageInfo, loading: pageInfoLoading } = (0, $cAdj8.usePageInfo)();
    // When the selectedAnnotation changes make sure we unset whatever resolved logic exists
    (0, $gwFzn.useEffect)(()=>{
        setResolvedComment(null);
        clearTimeout(resolveWindowCloseTimeout.current);
        resolveWindowCloseTimeout.current = undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedAnnotation
    ]);
    const [resolveInlineCommentFn] = (0, $diswb.useMutation)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $dhKx6.ResolveInlineCommentMutation));
    const [deleteInlineCommentFn] = (0, $diswb.useMutation)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $6Ebso.DeleteInlineCommentMutation));
    const [deleteInlineCommentWithStepFn] = (0, $diswb.useMutation)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $2Ntx6.DeleteInlineCommentMutationWithStep));
    const [createReplyFn] = (0, $diswb.useMutation)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $bZhP7.CreateInlineReplyMutation));
    // Editor setup
    const spaceId = pageInfo?.space?.id ?? '';
    const pageType = pageInfo?.type ?? '';
    // User page permissions
    const operations = pageInfo?.operations || [];
    // The user can upload media only if they have update permissions for the page
    const hasMediaUploadPermissions = operations.some((op)=>op?.operation === 'update' && op?.targetType === pageType);
    // Comment metadata
    const commentData = (0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment') ? data?.comments?.nodes?.[0] : data?.comments?.nodes?.[0];
    const topCommentUserId = commentData?.author?.accountId;
    const topCommentUserAvatar = commentData?.author?.profilePicture?.path;
    const topCommentDisplayName = commentData?.author?.displayName ?? 'Anonymous';
    const commentId = commentData?.id;
    const createdAtNonLocalized = commentData?.createdAtNonLocalized;
    const when = commentData?.version?.when;
    const versionByDisplayName = commentData?.version?.by?.displayName;
    const isEdited = (commentData?.version?.number || 0) > 1;
    const permissions = commentData?.permissions;
    const content = commentData?.body?.value;
    const permissionType = commentData?.author?.permissionType;
    const numReplies = commentData?.replies?.length || 0;
    const commentThreadLength = 1 + numReplies; // includes root comment
    const resolveProperties = commentData?.location?.inlineResolveProperties || undefined;
    const resolvedTime = commentData?.location?.inlineResolveProperties?.resolvedTime;
    const resolvedUser = commentData?.location?.inlineResolveProperties?.resolvedUser;
    const commentUrl = isEditor && !isLivePage ? commentData?.links.editui : commentData?.links.webui;
    const reactionsSummary = commentData?.reactionsSummary ?? null;
    const shouldCollapseReplies = isReplyChainCollapsed && numReplies && numReplies > (0, $bEwJH.MAX_UNCOLLAPSED_REPIES);
    const [{ orderedActiveAnnotationIdList: orderedActiveAnnotationIdList }, { addReplyToCommentThread: addReplyToCommentThread, handleRemovingComments: handleRemovingComments, deleteParentComment: deleteParentComment, resolveParentComment: resolveParentComment, setOrderedActiveAnnotationIdList: setOrderedActiveAnnotationIdList, updateUnreadStatus: updateUnreadStatus }] = (0, $8i27m.useCommentsData)();
    const handleUpdateUnreadStatus = (0, $gwFzn.useCallback)((commentIds)=>{
        // Update the Comments Panel's data cache that this comment has been read
        updateUnreadStatus({
            inline: {
                [selectedAnnotation.id]: commentIds
            },
            general: {}
        }, (0, $8i27m.UnreadAction).READ);
    }, [
        updateUnreadStatus,
        selectedAnnotation.id
    ]);
    const { unreadCommentRefs: unreadCommentRefs, currentUnreadIds: currentUnreadIds, markCommentReadError: markCommentReadError } = (0, $ICFae.useUnreadCommentsForInlineComment)({
        commentData: commentData,
        isEditor: Boolean(isEditor),
        focusedCommentId: focusedCommentId ?? null,
        shouldCollapseReplies: Boolean(shouldCollapseReplies),
        setIsReplyChainCollapsed: setIsReplyChainCollapsed,
        isInlineCommentVisible: isInlineCommentVisible,
        onUpdateUnreadStatus: handleUpdateUnreadStatus
    });
    const [, { updateSuggestedCommentIDMapLength: updateSuggestedCommentIDMapLength }] = (0, $kmw3a.useSuggestedComments)();
    const shouldDisplayCommentReplyPrompts = (0, $2qqNV.useShouldDisplayCommentReplyPrompts)({
        contentId: pageId,
        commentData: commentData,
        userId: currentUserId
    });
    (0, $gwFzn.useEffect)(()=>{
        RENDER_METRIC.start();
        experienceTracker.start({
            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
            id: selectedAnnotation.id,
            attributes: {
                mode: pageMode,
                framework: (0, $24amZ.InlineCommentFramework).ANNOTATION_PROVIDER
            }
        });
    }, [
        RENDER_METRIC,
        selectedAnnotation,
        experienceTracker,
        isEditor,
        pageMode
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (commentId) {
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'viewed',
                    actionSubject: 'inlineCommentsSidebar',
                    objectType: 'page',
                    objectId: pageId,
                    source: isEditor ? 'editPageScreen' : 'viewPageScreen',
                    attributes: {
                        mode: pageMode,
                        framework: (0, $24amZ.InlineCommentFramework).ANNOTATION_PROVIDER,
                        commentsDeckSize: numReplies + 1,
                        commentId: // +1 for the parent comment
                        commentId
                    }
                }
            }).fire();
            experienceTracker.succeed({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE)
            });
            updateSuggestedCommentIDMapLength(commentId, commentThreadLength);
        }
    // We really only need to depend on these two things and want this to fire when ONLY they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pageId,
        commentId
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (editCommentQueryId) {
            const isReplyToCommentInChain = commentData?.replies?.map((reply)=>reply?.id)?.includes(editCommentQueryId);
            if (isReplyToCommentInChain) setIsReplyChainCollapsed(false);
            setCommentForEdit(editCommentQueryId);
        }
    }, [
        editCommentQueryId,
        commentData
    ]);
    (0, $gwFzn.useEffect)(()=>{
        const isReplyToCommentInChain = commentData?.replies?.map((reply)=>reply?.id)?.includes(replyToCommentId);
        setShouldFocusNewReply(Boolean(replyToCommentId) && (isReplyToCommentInChain || replyToCommentId === commentId));
    }, [
        replyToCommentId,
        commentId,
        commentData
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (focusedCommentId) {
            const isReplyToCommentInChain = commentData?.replies?.map((reply)=>reply?.id)?.includes(focusedCommentId);
            if (isReplyToCommentInChain) setIsReplyChainCollapsed(false);
        }
    }, [
        focusedCommentId,
        commentData
    ]);
    (0, $gwFzn.useEffect)(()=>{
        const resolved = commentData?.location?.inlineResolveProperties?.resolved;
        if (resolved && !isEditor) {
            const commentId = commentData?.id;
            const markerRef = commentData?.location?.inlineMarkerRef;
            if (commentId && markerRef) {
                setResolvedComment({
                    commentId: commentId,
                    inlineMarkerRef: markerRef
                });
                eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_STATE, {
                    [markerRef]: {
                        id: markerRef,
                        annotationType: (0, $cdbMf.AnnotationTypes).INLINE_COMMENT,
                        state: (0, $cdbMf.AnnotationMarkStates).RESOLVED
                    }
                });
            }
        }
    }, [
        commentData,
        eventEmitter,
        isEditor
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (loading === false && pageInfoLoading === false && !(0, $9wGTI.fg)('confluence_frontend_comments_inline_apollo_loading')) {
            if ((0, $9wGTI.fg)('confluence_frontend_create_to_view_transition')) // Close the create comment component when the view component is ready
            handleCloseCreateComment();
            setShouldRender(true);
            (0, $4EKKB.selectInlineCommentCompoundExperience).showComment.debugPoint('Data loaded, showing comment');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        loading,
        pageInfoLoading
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (data && pageInfo && (0, $9wGTI.fg)('confluence_frontend_comments_inline_apollo_loading')) {
            if ((0, $9wGTI.fg)('confluence_frontend_create_to_view_transition')) // Close the create comment component when the view component is ready
            handleCloseCreateComment();
            setShouldRender(true);
            (0, $4EKKB.selectInlineCommentCompoundExperience).showComment.debugPoint('Data loaded, showing comment');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        data,
        pageInfo
    ]);
    (0, $gwFzn.useEffect)(()=>{
        return ()=>{
            setShouldRender(false);
            (0, $4EKKB.selectInlineCommentCompoundExperience).showComment.debugPoint('Data changed, hiding comment', {
                ...!!commentId && {
                    commentId: commentId
                },
                pageId: pageId,
                selectedAnnotationId: selectedAnnotation.id
            });
        };
    }, [
        commentId,
        pageId,
        selectedAnnotation
    ]);
    (0, $gwFzn.useEffect)(()=>{
        // if the user has been shown the resolved comment view, but navigated away to another comment
        // we need to cancel the autodismiss functionality, as it will close this entire view and not just the
        // resolved comment notification
        if (commentId !== resolvedComment?.commentId) {
            clearTimeout(resolveWindowCloseTimeout.current);
            resolveWindowCloseTimeout.current = undefined;
        }
    }, [
        commentId,
        resolvedComment,
        resolveWindowCloseTimeout
    ]);
    const toggleCommentMode = (id = '')=>{
        setCommentForEdit(id);
    };
    (0, $gwFzn.useEffect)(()=>{
        const markerRef = commentData?.location?.inlineMarkerRef;
        if (markerRef) setActiveHighlight(markerRef);
    }, [
        commentData,
        setActiveHighlight
    ]);
    (0, $gwFzn.useEffect)(()=>{
        return ()=>{
            setActiveHighlight(null);
        };
    }, [
        setActiveHighlight
    ]);
    // Not used
    const updateApolloCacheForReply = (0, $gwFzn.useCallback)((actionType, commentId)=>(cache, result)=>{
            // If the mutation fails, don't do anything
            if (!result) return;
            const queryVariables = {
                pageId: pageId,
                annotationId: selectedAnnotation?.id,
                contentStatus: [
                    'DRAFT',
                    'CURRENT'
                ]
            };
            try {
                const response = cache.readQuery({
                    query: (0, $3B9cR.InlineCommentQuery),
                    variables: queryVariables
                });
                if (!response) return;
                // grab the parent comment
                const parentComment = response?.comments?.nodes?.[0];
                let duplicatedReplies = null;
                if (parentComment) {
                    if (actionType === 'delete') {
                        duplicatedReplies = [
                            ...parentComment.replies
                        ];
                        // Remove the returned commentId from the cache and reset it
                        const idxToRemove = duplicatedReplies.findIndex((reply)=>reply?.id === commentId);
                        if (idxToRemove !== -1) duplicatedReplies.splice(idxToRemove, 1);
                    } else {
                        const mutationResult = result.data.replyInlineComment;
                        // Add the new reply entry to the cache and reset it
                        duplicatedReplies = [
                            ...parentComment.replies
                        ];
                        duplicatedReplies.push(mutationResult);
                    }
                    if (duplicatedReplies) {
                        const updatedResponse = {
                            ...response,
                            comments: {
                                ...response.comments,
                                nodes: [
                                    {
                                        ...parentComment,
                                        replies: duplicatedReplies
                                    }
                                ]
                            }
                        };
                        cache.writeQuery({
                            query: (0, $3B9cR.InlineCommentQuery),
                            variables: queryVariables,
                            data: updatedResponse
                        });
                    }
                }
            } catch (err) {
                $f4f7ab8b4171ff8f$var$logger.error`An Error occurred when updating cache for ${actionType} reply - ${err}`;
            }
        }, [
        selectedAnnotation,
        pageId
    ]);
    const handleReplyToComment = (id, commentReplyData)=>{
        const referencedData = commentReplyData || commentData;
        setShouldFocusNewReply(true);
        setReplyToCommentId({
            parentCommentId: id,
            location: (0, $i6UMJ.LocationValue).STANDALONE,
            user: {
                displayName: referencedData?.author?.displayName,
                accountId: referencedData?.author?.accountId
            }
        });
    };
    const handleDeleteCommentInRenderer = (0, $gwFzn.useCallback)((parentId, replyCommentId)=>{
        const isReply = Boolean(parentId);
        let deleteResult;
        let mtnVariables;
        if (isReply) mtnVariables = {
            variables: {
                commentIdToDelete: replyCommentId,
                deleteFrom: (0, $8z9UY.CommentDeletionLocation).LIVE
            }
        };
        else {
            try {
                // Call deleteAnnotation(selectedAnnotation) to get step and any other required variables
                deleteResult = deleteOptions?.deleteAnnotation(selectedAnnotation);
            } catch (e) {
                experienceTracker.stopOnError({
                    name: (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE),
                    error: e
                });
                return;
            }
            if (!deleteResult) {
                experienceTracker.stopOnError({
                    name: (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE),
                    error: new Error(`Unable to remove annotation ${selectedAnnotation.id} from document`)
                });
                return;
            }
            mtnVariables = {
                variables: {
                    input: {
                        commentId: commentId,
                        step: (0, $aMfLn.constructStepForGql)(deleteResult.step)
                    }
                }
            };
        }
        // After deleting it will not be available, so we need to get the inline node types before deleting.
        const inlineNodeTypes = selectedAnnotation ? getInlineNodeTypes(selectedAnnotation.id) : undefined;
        // top-level comment calls `deleteInlineCommentWithStepFn`
        // reply calls `deleteInlineComment`
        const deleteFn = isReply ? deleteInlineCommentFn : deleteInlineCommentWithStepFn;
        deleteFn({
            ...mtnVariables,
            update: isReply ? apolloCacheCallback('delete', {
                pageId: pageId,
                annotationId: selectedAnnotation.id,
                contentStatus: (0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment') ? [
                    'DRAFT',
                    'CURRENT'
                ] : [
                    'CURRENT',
                    'DRAFT'
                ]
            }, parentId, replyCommentId) : undefined
        }).then((retVal)=>{
            const { data: deleteResultData } = retVal;
            if (!deleteResultData || !isReply && !deleteResultData.deleteInlineComment) throw new Error('No data returned from mutation');
            const deleteAnnotationAndCleanUp = (annotationId)=>{
                if (!isReply) {
                    // We handle this being false above and can't get here if it is
                    if (deleteResult) deleteOptions?.onDeleteSuccess(deleteResult.doc, annotationId);
                    // Reset the content state on successful deletion on a non-reply
                    resetContentChanged();
                    onClose && onClose();
                    deleteParentComment({
                        threadKey: annotationId,
                        commentType: (0, $8i27m.CommentType).INLINE
                    });
                } else if (replyCommentId) handleRemovingComments({
                    threadKey: annotationId,
                    commentId: replyCommentId,
                    action: (0, $8i27m.CommentActionType).DELETE_COMMENT,
                    commentType: (0, $8i27m.CommentType).INLINE
                });
                experienceTracker.succeed({
                    name: (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE)
                });
            };
            (0, $8dA1U.handleDeleteSuccess)({
                commentId: isReply ? replyCommentId : commentId,
                annotationId: selectedAnnotation?.id,
                pageId: pageId,
                pageMode: pageMode,
                isReply: isReply,
                source: (0, $en1dX.AnalyticsSource).STANDALONE,
                inlineNodeTypes: inlineNodeTypes,
                createAnalyticsEvent: createAnalyticsEvent,
                removeUnresolvedInlineComment: removeUnresolvedInlineComment,
                onSuccess: deleteAnnotationAndCleanUp
            });
        }).catch((err)=>{
            if ((0, $9wGTI.fg)('confluence_frontend_show_already_deleted_flag')) {
                const parsedError = (0, $isdzP.parseError)(err);
                const translatedError = (0, $isdzP.getTranslatedError)(parsedError.message, isReply ? replyCommentId : commentId);
                if ((0, $isdzP.isAlreadyDeletedError)(translatedError)) {
                    flags.showWarningFlag({
                        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $f4f7ab8b4171ff8f$var$i18n.cannotDeleteTitle),
                        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), translatedError)
                    });
                    createAnalyticsEvent({
                        type: 'sendOperationalEvent',
                        data: {
                            action: 'alreadyDeleted',
                            actionSubject: 'comment',
                            actionSubjectId: isReply ? replyCommentId : commentId,
                            objectType: 'page',
                            objectId: pageId,
                            source: 'viewPageScreen',
                            attributes: {
                                commentType: 'inline',
                                mode: pageMode,
                                framework: (0, $24amZ.InlineCommentFramework).ANNOTATION_PROVIDER,
                                isReply: isReply
                            }
                        }
                    }).fire();
                }
            }
            (0, $8dA1U.handleMutationFailure)({
                experienceTracker: experienceTracker,
                experienceName: (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE),
                error: err,
                commentId: isReply ? replyCommentId : commentId
            });
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        commentId,
        createAnalyticsEvent,
        deleteOptions,
        experienceTracker,
        resetContentChanged,
        onClose,
        pageId,
        removeUnresolvedInlineComment,
        selectedAnnotation,
        deleteInlineCommentFn,
        deleteInlineCommentWithStepFn,
        pageMode,
        getInlineNodeTypes,
        handleRemovingComments,
        deleteParentComment,
        flags
    ]);
    const handleDeleteCommentInEditorAndLivePages = (0, $gwFzn.useCallback)((parentId, replyCommentId)=>{
        const isReply = Boolean(parentId);
        const targetNodeType = (0, $asNlu.getTargetNodeType)(selectedAnnotation.id, true);
        // both top-level comments and replies call `deleteInlineComment`
        deleteInlineCommentFn({
            variables: {
                commentIdToDelete: isReply ? replyCommentId : commentId,
                deleteFrom: isLivePage ? (0, $8z9UY.CommentDeletionLocation).LIVE : (0, $8z9UY.CommentDeletionLocation).EDITOR
            },
            update: isReply ? apolloCacheCallback('delete', {
                pageId: pageId,
                annotationId: selectedAnnotation.id,
                contentStatus: (0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment') ? [
                    'DRAFT',
                    'CURRENT'
                ] : [
                    'CURRENT',
                    'DRAFT'
                ]
            }, parentId, replyCommentId) : undefined
        }).then(({ data: deleteResultData })=>{
            if (!deleteResultData || !isReply && !deleteResultData.deleteComment) throw new Error('No data returned from mutation');
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'deleted',
                    actionSubject: 'comment',
                    actionSubjectId: isReply ? replyCommentId : commentId,
                    objectType: 'page',
                    objectId: pageId,
                    source: 'editPageScreen',
                    attributes: {
                        commentType: (0, $8i27m.CommentType).INLINE,
                        source: (0, $en1dX.AnalyticsSource).STANDALONE,
                        pageMode: pageMode,
                        framework: (0, $24amZ.InlineCommentFramework).ANNOTATION_PROVIDER,
                        inlineNodeTypes: selectedAnnotation ? getInlineNodeTypes(selectedAnnotation.id) : undefined,
                        isReply: isReply,
                        targetNodeType: targetNodeType
                    }
                }
            }).fire();
            experienceTracker.succeed({
                name: (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE)
            });
            if (!isReply) {
                onDelete?.(selectedAnnotation?.id);
                // Remove the comment from the unresolved list
                removeUnresolvedInlineComment(selectedAnnotation?.id);
                // Reset the content state on successful deletion on a non-reply
                resetContentChanged();
                deleteParentComment({
                    threadKey: selectedAnnotation.id,
                    commentType: (0, $8i27m.CommentType).INLINE
                });
            } else if (replyCommentId) handleRemovingComments({
                threadKey: selectedAnnotation.id,
                commentId: replyCommentId,
                action: (0, $8i27m.CommentActionType).DELETE_COMMENT,
                commentType: (0, $8i27m.CommentType).INLINE
            });
        }).catch((err)=>{
            if ((0, $9wGTI.fg)('confluence_frontend_show_already_deleted_flag')) {
                const parsedError = (0, $isdzP.parseError)(err);
                const translatedError = (0, $isdzP.getTranslatedError)(parsedError.message, isReply ? replyCommentId : commentId);
                if ((0, $isdzP.isAlreadyDeletedError)(translatedError)) {
                    flags.showWarningFlag({
                        id: commentId,
                        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $f4f7ab8b4171ff8f$var$i18n.cannotDeleteTitle),
                        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), translatedError)
                    });
                    createAnalyticsEvent({
                        type: 'sendOperationalEvent',
                        data: {
                            action: 'alreadyDeleted',
                            actionSubject: 'comment',
                            actionSubjectId: isReply ? replyCommentId : commentId,
                            objectType: 'page',
                            objectId: pageId,
                            source: 'editPageScreen',
                            attributes: {
                                commentType: 'inline',
                                mode: pageMode,
                                framework: (0, $24amZ.InlineCommentFramework).ANNOTATION_PROVIDER,
                                isReply: isReply
                            }
                        }
                    }).fire();
                }
            }
            (0, $8dA1U.handleMutationFailure)({
                experienceTracker: experienceTracker,
                experienceName: (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE),
                error: err,
                commentId: isReply ? replyCommentId : commentId
            });
        });
    }, //TODO FIXME: determine the right dep array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        commentId,
        createAnalyticsEvent,
        deleteInlineCommentFn,
        experienceTracker,
        pageMode,
        pageId,
        onDelete,
        selectedAnnotation,
        getInlineNodeTypes,
        resetContentChanged,
        isLivePage,
        removeUnresolvedInlineComment,
        handleRemovingComments,
        flags
    ]);
    const handleDeleteComment = (0, $gwFzn.useCallback)((parentId, replyCommentId)=>{
        if (!isEditor) handleDeleteCommentInRenderer(parentId, replyCommentId);
        else handleDeleteCommentInEditorAndLivePages(parentId, replyCommentId);
    }, [
        isEditor,
        handleDeleteCommentInRenderer,
        handleDeleteCommentInEditorAndLivePages
    ]);
    const handleResolveComment = ()=>{
        const mtnVariables = {
            variables: {
                commentId: commentId,
                resolved: true
            }
        };
        resolveInlineCommentFn(mtnVariables).then(()=>{
            const annotationId = selectedAnnotation.id;
            // this will be removed when the prop becomes optional
            onResolve(annotationId);
            (0, $8dA1U.handleResolveSuccess)({
                commentId: commentId,
                parentCommentMarkerRef: annotationId,
                pageId: pageId,
                pageMode: pageMode,
                eventEmitter: eventEmitter,
                source: (0, $en1dX.AnalyticsSource).STANDALONE,
                removeUnresolvedInlineComment: removeUnresolvedInlineComment,
                createAnalyticsEvent: createAnalyticsEvent,
                getInlineNodeTypes: getInlineNodeTypes,
                commentType: (0, $8i27m.CommentType).INLINE
            });
            resolveParentComment({
                threadKey: annotationId,
                commentType: (0, $8i27m.CommentType).INLINE
            });
            setOrderedActiveAnnotationIdList(orderedActiveAnnotationIdList.map((status)=>status.threadKey).filter((id)=>id !== annotationId));
            experienceTracker.succeed({
                name: (0, $irVI7.RESOLVE_INLINE_COMMENT_EXPERIENCE)
            });
            // Show the resolved comment window if not in editor
            if (!isEditor) {
                if (commentId) setResolvedComment({
                    commentId: commentId,
                    inlineMarkerRef: annotationId
                });
                // If the comment we just resolved is the same as the one we're currently viewing, set a timeout
                // to auto-close the container as it should be showing the resolved comment notification view
                if (resolvedComment?.commentId === commentData?.id) resolveWindowCloseTimeout.current = setTimeout(()=>{
                    onClose && onClose();
                }, 7500);
            }
        }).catch((err)=>{
            (0, $8dA1U.handleMutationFailure)({
                experienceTracker: experienceTracker,
                experienceName: (0, $irVI7.RESOLVE_INLINE_COMMENT_EXPERIENCE),
                error: err
            });
        });
    };
    const onCancelComment = ()=>{
        setReplyToCommentId();
        setShouldFocusNewReply(false);
    };
    const handleCreateReplyUnified = async (adf, onSuccess)=>{
        const parentCommentId = commentId ?? '';
        const variables = {
            input: {
                containerId: pageId,
                parentCommentId: parentCommentId,
                commentBody: {
                    value: JSON.stringify(adf),
                    representationFormat: 'ATLAS_DOC_FORMAT'
                },
                createdFrom: isLivePage ? (0, $afGoD.CommentCreationLocation).LIVE : isEditor ? (0, $afGoD.CommentCreationLocation).EDITOR : (0, $afGoD.CommentCreationLocation).RENDERER
            },
            pageId: pageId
        };
        const queryVariables = {
            annotationId: selectedAnnotation?.id,
            pageId: pageId,
            contentStatus: [
                'DRAFT',
                'CURRENT'
            ]
        };
        if ((0, $9wGTI.fg)('confluence_frontend_experience_trace_id')) (0, $8Ss4E.startEditorSubExperience)({
            name: (0, $irVI7.REPLY_TO_INLINE_COMMENT_PUBLISH_EXPERIENCE),
            attributes: {
                parentCommentId: parentCommentId
            }
        });
        else experienceTracker.start({
            name: (0, $irVI7.REPLY_TO_INLINE_COMMENT_PUBLISH_EXPERIENCE),
            attributes: {
                parentCommentId: parentCommentId
            }
        });
        return createReplyFn({
            variables: variables,
            update: apolloCacheCallback('create', queryVariables, parentCommentId)
        }).then(({ data: data })=>{
            const replyInlineComment = data.replyInlineComment;
            const reply = {
                ...replyInlineComment,
                isUnread: false
            };
            addReplyToCommentThread(selectedAnnotation.id, reply, (0, $8i27m.CommentType).INLINE);
            (0, $g0DaR.handleCreateReplySuccess)({
                onSuccess: onSuccess,
                editCommentQueryId: editCommentQueryId,
                setCommentForEdit: setCommentForEdit,
                data: data,
                createAnalyticsEvent: createAnalyticsEvent,
                pageId: pageId,
                pageType: pageType,
                analyticsSource: (0, $en1dX.AnalyticsSource).STANDALONE,
                commentId: commentId,
                pageMode: pageMode,
                selectedAnnotation: selectedAnnotation,
                getInlineNodeTypes: undefined,
                experienceTracker: experienceTracker,
                isEditor: !!isEditor
            });
        }).catch((error)=>{
            return (0, $8dA1U.handleMutationFailure)({
                experienceTracker: experienceTracker,
                experienceName: (0, $irVI7.REPLY_TO_INLINE_COMMENT_PUBLISH_EXPERIENCE),
                error: error,
                commentId: commentId,
                shouldReturnError: true,
                shouldAbortForExpectedError: true,
                compoundExperienceName: (0, $irVI7.REPLY_TO_INLINE_COMMENT_EXPERIENCE)
            });
        });
    };
    // TODO: Delete handleCreateReply when removing the unified_create_comment_reply_function FG
    const handleCreateReply = async (adf, onSuccess)=>{
        let createdFrom;
        if (isLivePage) createdFrom = (0, $afGoD.CommentCreationLocation).LIVE;
        else createdFrom = isEditor ? (0, $afGoD.CommentCreationLocation).EDITOR : (0, $afGoD.CommentCreationLocation).RENDERER;
        const variables = {
            input: {
                containerId: pageId,
                parentCommentId: commentId ?? '',
                commentBody: {
                    value: JSON.stringify(adf),
                    representationFormat: 'ATLAS_DOC_FORMAT'
                },
                createdFrom: createdFrom
            },
            pageId: pageId
        };
        return createReplyFn({
            variables: variables,
            update: updateApolloCacheForReply('create') // Not used
        }).then(({ data: data })=>{
            // reset the editor
            onSuccess();
            if (editCommentQueryId) setCommentForEdit('');
            const replyCommentInfo = data?.replyInlineComment;
            const markerRef = replyCommentInfo?.location?.inlineMarkerRef;
            const reply = {
                ...replyCommentInfo,
                isUnread: false
            };
            addReplyToCommentThread(markerRef, reply, (0, $8i27m.CommentType).INLINE);
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'created',
                    actionSubject: 'comment',
                    actionSubjectId: replyCommentInfo?.id,
                    // The newly created comment ID
                    objectType: pageType,
                    objectId: pageId,
                    source: isEditor ? 'editPageScreen' : 'viewPageScreen',
                    attributes: {
                        source: (0, $en1dX.AnalyticsSource).STANDALONE,
                        commentType: 'inline',
                        parentCommentId: commentId ?? null,
                        // analytics event schema type expects string or null
                        isReply: true,
                        pageMode: pageMode,
                        framework: (0, $24amZ.InlineCommentFramework).ANNOTATION_PROVIDER,
                        navdexPointType: (0, $dEBDF.END),
                        inlineNodeTypes: selectedAnnotation ? getInlineNodeTypes(selectedAnnotation.id) : undefined,
                        targetNodeType: (0, $asNlu.getTargetNodeType)(markerRef, isEditor)
                    }
                }
            }).fire();
            experienceTracker.succeed({
                name: (0, $irVI7.REPLY_TO_INLINE_COMMENT_EXPERIENCE)
            });
        }).catch((err)=>{
            return (0, $8dA1U.handleMutationFailure)({
                experienceTracker: experienceTracker,
                experienceName: (0, $irVI7.REPLY_TO_INLINE_COMMENT_EXPERIENCE),
                error: err,
                shouldReturnError: true
            });
        });
    };
    const updateReactionsCacheFnLegacy = (0, $gwFzn.useCallback)((emojiId, actionType, objectId, containerId, cache)=>{
        const queryVariables = {
            pageId: containerId,
            annotationId: selectedAnnotation?.id,
            contentStatus: [
                isArchived ? 'ARCHIVED' : 'DRAFT',
                'CURRENT'
            ]
        };
        try {
            const response = cache?.readQuery({
                query: (0, $3B9cR.InlineCommentQuery),
                variables: queryVariables
            });
            if (!response?.comments?.nodes?.[0]) return;
            const comment = response.comments.nodes[0];
            let cacheReactionsSummary;
            let reply;
            // If the comment matches the comment ID, use it's reactionsSummary
            if (comment.id === objectId) cacheReactionsSummary = {
                ...comment.reactionsSummary
            };
            else {
                // Otherwise, find the reply that matches
                reply = comment.replies.find((r)=>r?.id === objectId);
                if (reply) cacheReactionsSummary = {
                    ...reply.reactionsSummary
                };
            }
            if (!cacheReactionsSummary) return;
            const reactionsAri = cacheReactionsSummary.ari || '';
            const reactionsContainerAri = cacheReactionsSummary.containerAri || '';
            let reactionsCount = cacheReactionsSummary.reactionsCount || 0;
            const updatedReactionsSummary = {
                ...cacheReactionsSummary
            };
            const updatedReactionsNodes = [
                ...cacheReactionsSummary.reactionsSummaryForEmoji || []
            ];
            if (actionType === 'add') {
                const reaction = updatedReactionsNodes.find((item)=>item?.emojiId === emojiId);
                // If reaction exists, update its attributes
                if (reaction && !reaction.reacted) {
                    reaction.count++;
                    reaction.reacted = true;
                } else {
                    // Otherwise, create a new reaction
                    const newReaction = {
                        emojiId: emojiId,
                        count: 1,
                        reacted: true,
                        id: `${reactionsContainerAri}|${reactionsAri}|${emojiId}`,
                        __typename: 'ReactionsSummaryForEmoji'
                    };
                    updatedReactionsNodes.push(newReaction);
                }
                ++reactionsCount;
            } else if (actionType === 'delete') {
                const reactionIdx = updatedReactionsNodes.findIndex((item)=>item?.emojiId === emojiId);
                // If reaction exists, update its attributes
                if (reactionIdx !== -1) {
                    const reaction = updatedReactionsNodes[reactionIdx];
                    // If we have more than one reaction, remove our user from it and decrement the count
                    if (reaction && reaction.count > 1) {
                        reaction.count--;
                        reaction.reacted = false;
                    } else // Otherwise, remove the reaction entirely
                    updatedReactionsNodes.splice(reactionIdx, 1);
                    --reactionsCount;
                }
            }
            updatedReactionsSummary.reactionsSummaryForEmoji = updatedReactionsNodes;
            updatedReactionsSummary.reactionsCount = reactionsCount ?? 0;
            // Create a deep copy of the comment to ensure Apollo detects the change
            const updatedComment = {
                ...comment,
                replies: comment.replies.map((r)=>{
                    if (r?.id === objectId) return {
                        ...r,
                        reactionsSummary: updatedReactionsSummary
                    };
                    return r;
                })
            };
            // Update the comment's reactionsSummary if it's the target comment
            if (comment.id === objectId) // @ts-ignore reactionsCount will always be defined, so the type comparison is wrong
            updatedComment.reactionsSummary = updatedReactionsSummary;
            const newData = {
                comments: {
                    nodes: [
                        updatedComment
                    ],
                    __typename: 'PaginatedCommentList'
                }
            };
            cache?.writeQuery({
                query: (0, $3B9cR.InlineCommentQuery),
                variables: queryVariables,
                data: newData
            });
        } catch (err) {
            $f4f7ab8b4171ff8f$var$logger.error`An error occurred when updating reactions cache for ${actionType} - ${err}`;
        }
    }, [
        selectedAnnotation,
        isArchived
    ]);
    const updateReactionsCacheFn = (0, $gwFzn.useCallback)((emojiId, actionType, objectId, containerId, cache)=>{
        return (0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment') ? (0, $g0DaR.updateReactionsCacheCallbackForGA)(emojiId, actionType, objectId, pageId, selectedAnnotation, isArchived ?? false, cache) : updateReactionsCacheFnLegacy(emojiId, actionType, objectId, containerId, cache);
    }, [
        pageId,
        selectedAnnotation,
        isArchived,
        updateReactionsCacheFnLegacy
    ]);
    const renderReplies = (0, $gwFzn.useCallback)((shouldCollapseReplies)=>{
        const replies = data?.comments?.nodes?.[0]?.replies || [];
        const visibleReplies = shouldCollapseReplies ? replies.slice(-1) : replies;
        return visibleReplies.map((reply)=>{
            if (!reply) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null);
            const { id: id, permissions: replyPermissions, body: body, reactionsSummary: replyReactionsSummary } = reply;
            const matchingRef = unreadCommentRefs.find((refObj)=>refObj.id === id)?.ref;
            if (id === editCommentId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $auGhu.EditComment), {
                key: id,
                commentId: id,
                annotationId: selectedAnnotation.id,
                displayName: reply.author?.displayName ?? 'Anonymous',
                avatarUrl: reply.author?.profilePicture?.path ?? '',
                pageId: pageId,
                pageType: pageType,
                spaceId: spaceId,
                content: body?.value,
                displayCommentInViewMode: toggleCommentMode,
                mode: isEditor ? 'edit' : 'view',
                isReply: true,
                hasMediaUploadPermissions: hasMediaUploadPermissions,
                getInlineNodeTypes: getInlineNodeTypes,
                commentType: (0, $8i27m.CommentType).INLINE
            });
            else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kEmgx.CommentBody), {
                key: id,
                userId: reply.author?.accountId ?? '',
                displayName: reply.author?.displayName,
                avatarUrl: reply.author?.profilePicture?.path,
                date: reply.version?.when ?? '',
                dateUrl: isEditor && !isLivePage ? reply.links.editui ?? undefined : reply.links.webui ?? undefined,
                createdAtNonLocalized: reply.createdAtNonLocalized ?? '',
                versionDate: reply.version?.when ?? '',
                versionByDisplayName: reply.version?.by?.displayName,
                commentId: id,
                pageId: pageId,
                pageType: pageType,
                isReply: true,
                isEdited: (reply.version?.number || 0) > 1,
                parentCommentId: reply.parentId,
                permissions: replyPermissions,
                editComment: ()=>toggleCommentMode(id),
                deleteComment: ()=>handleDeleteComment(reply.parentId, id),
                content: reply.body?.value,
                isCommentActive: true,
                mode: isEditor ? 'edit' : 'view',
                permissionType: reply.author?.permissionType ?? undefined,
                supportedActions: [
                    'edit',
                    'delete',
                    'resolve'
                ],
                isFocused: focusedCommentId === id,
                isUnread: currentUnreadIds.has(id),
                onRendered: ()=>{
                    const targetCommentId = focusedCommentId || replyToCommentId;
                    if (sidebarOffset > 0 && targetCommentId) (0, $aHcFH.handleScrollToElement)({
                        commentId: id,
                        targetCommentId: targetCommentId,
                        isEditor: Boolean(isEditor),
                        useInstantScroll: true
                    });
                },
                unreadCommentRef: matchingRef,
                commentType: (0, $8i27m.CommentType).INLINE,
                inheritedReactionsData: replyReactionsSummary,
                reactionsCacheUpdateFn: updateReactionsCacheFn,
                isOffline: isOffline
            });
        });
    }, [
        data,
        editCommentId,
        pageType,
        pageId,
        spaceId,
        selectedAnnotation,
        isEditor,
        focusedCommentId,
        replyToCommentId,
        handleDeleteComment,
        isLivePage,
        sidebarOffset,
        currentUnreadIds,
        unreadCommentRefs,
        hasMediaUploadPermissions,
        getInlineNodeTypes,
        updateReactionsCacheFn,
        isOffline
    ]);
    const handleOnClose = (0, $gwFzn.useCallback)(()=>{
        const isReply = editCommentId === '';
        experienceTracker.abort({
            name: isReply ? (0, $irVI7.REPLY_TO_INLINE_COMMENT_EXPERIENCE) : (0, $irVI7.EDIT_INLINE_COMMENT_EXPERIENCE),
            reason: 'comment discarded by user'
        });
        // Clearing reply draft is handled in the comment editor
        (0, $aGjYc.clearCommentDraft)(isEditor ? 'edit-inline' : 'inline', isReply ? 'reply' : 'edit');
        setIsReplyChainCollapsed(true);
        setShouldFocusNewReply(false);
        onClose && onClose();
    }, [
        experienceTracker,
        editCommentId,
        isEditor,
        onClose
    ]);
    const handleReopen = (0, $gwFzn.useCallback)((annotationId)=>{
        // Trigger a refetch to get the new details when we reopen the comment
        refetch().then(()=>{
            // Emit the event to re-highlight the mark
            eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_STATE, {
                [annotationId]: {
                    id: annotationId,
                    annotationType: (0, $cdbMf.AnnotationTypes).INLINE_COMMENT,
                    state: (0, $cdbMf.AnnotationMarkStates).ACTIVE
                }
            });
            addUnresolvedInlineComment(annotationId, pageMode);
            // Show the comment again in the sidebar and clear the timeout
            setResolvedComment(null);
        }).catch((error)=>{
            $f4f7ab8b4171ff8f$var$logger.error`Unable to refetch the details of the comment; ${error}`;
        });
        clearTimeout(resolveWindowCloseTimeout.current);
        resolveWindowCloseTimeout.current = undefined;
    }, [
        eventEmitter,
        setResolvedComment,
        addUnresolvedInlineComment,
        refetch,
        pageMode
    ]);
    const navigationOptions = (0, $gwFzn.useMemo)(()=>({
            // We don't want to show the comment counts for the resolved comment view, and we need to make sure
            // that we're not actually viewing a different comment to the resolved comment
            disableCommentCount: Boolean(resolvedComment?.commentId === commentData?.id) || (0, $9wGTI.fg)('confluence-frontend-comments-panel'),
            commentData: commentData,
            onNavigationClick: onNavigationClick
        }), [
        resolvedComment,
        commentData,
        onNavigationClick
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (!selectedAnnotation.id) return;
        if (shouldRender === false) {
            // The UI has not started rendering yet, so we don't want to check if it's visible.
            (0, $4EKKB.selectInlineCommentCompoundExperience).showComment.debugPoint('InlineComment has been rendered, but is returning null due to shouldRender');
            return;
        }
        const initialTaskId = experienceTracker.getExperienceState((0, $irVI7.SELECT_INLINE_COMMENT_SHOW_COMMENT_EXPERIENCE))?.taskId;
        setTimeout(()=>{
            // There are multiple apis and effects involved in swapping from the create comment
            // ui to the view comment ui.
            // This works around this by only marking the experience as complete after
            // a short timeout + animation frame.
            requestAnimationFrame(()=>{
                const currentTaskId = experienceTracker.getExperienceState((0, $irVI7.SELECT_INLINE_COMMENT_SHOW_COMMENT_EXPERIENCE))?.taskId;
                if (initialTaskId !== currentTaskId) // The experience has been restarted or has otherwise ended.
                return;
                if (lastSelected.current !== selectedAnnotation.id) {
                    // The selected annotation has changed, this should have led to an earlier abort
                    // (as an overlapping experience is started)
                    (0, $4EKKB.selectInlineCommentCompoundExperience).showComment.debugPoint('Show comment assumed aborted due to selection change');
                    return;
                }
                if (!annotationElementRef.current) {
                    // We'd expect the select annotation experience to fail
                    // if no annotation is added to the document
                    // Assume this experience has aborted (or it will timeout)
                    (0, $4EKKB.selectInlineCommentCompoundExperience).showComment.debugPoint('Show comment assumed aborted by deselection or selection change');
                    return;
                }
                if (!sidebarEl.current) {
                    (0, $4EKKB.selectInlineCommentCompoundExperience).showComment.fail(new Error('Document missing inline comment ui'));
                    return;
                }
                const commentUIVerticalDistanceFromAnnotation = Math.abs(annotationElementRef.current.getBoundingClientRect().top - sidebarEl.current.getBoundingClientRect?.().top);
                // The 10 pixel allowance has been arbitrarily chosen to allow for some wiggle room
                if (commentUIVerticalDistanceFromAnnotation > 40) {
                    const isVisible = sidebarEl.current.checkVisibility();
                    if (isVisible) // if it's fully visible, but misaligned, we don't treat this as a failure
                    (0, $4EKKB.selectInlineCommentCompoundExperience).showComment.debug({
                        error: new Error('View Created Comment UI too far from annotation'),
                        createAnalyticsEvent: createAnalyticsEvent,
                        extraAttributes: {
                            misalignedBy: commentUIVerticalDistanceFromAnnotation
                        }
                    });
                    else {
                        (0, $4EKKB.selectInlineCommentCompoundExperience).showComment.fail(new Error('View Created Comment UI too far from annotation'), {
                            misalignedBy: commentUIVerticalDistanceFromAnnotation
                        });
                        return;
                    }
                }
                (0, $4EKKB.selectInlineCommentCompoundExperience).showComment.complete();
            });
        }, 1000);
    }, [
        selectedAnnotation.id,
        shouldRender,
        createAnalyticsEvent,
        experienceTracker
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if ((0, $9wGTI.fg)('confluence_comments_select_comment_experience')) return ()=>{
            // If a show inline comment experience is still running while this component is in the process of being
            // unmounted, we abort it rather than fail it.
            (0, $4EKKB.selectInlineCommentCompoundExperience).showComment.abort({
                abortReason: 'Comment sidebar dismissed'
            });
        };
    }, []);
    const [isStandalonehovered, setisStandalonehovered] = (0, $gwFzn.useState)(false);
    const [hoveredCommentId, setHoveredCommentId] = (0, $gwFzn.useState)(undefined);
    const handleMouseEnter = (0, $gwFzn.useCallback)((id)=>{
        if (!(0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment')) return;
        setisStandalonehovered(true);
        if (id) setHoveredCommentId(id);
    }, []);
    const handleMouseLeave = (0, $gwFzn.useCallback)(()=>{
        if (!(0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment')) return;
        setisStandalonehovered(false);
        setHoveredCommentId(undefined);
    }, []);
    if (!shouldRender) return null;
    const renderComment = ()=>{
        const matchingRef = unreadCommentRefs.find((refObj)=>refObj.id === commentId)?.ref;
        if (commentId === editCommentId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $auGhu.EditComment), {
            pageId: pageId,
            pageType: pageType,
            annotationId: selectedAnnotation.id,
            commentId: commentId,
            spaceId: spaceId,
            content: content ?? '',
            isReply: false,
            displayCommentInViewMode: toggleCommentMode,
            avatarUrl: topCommentUserAvatar ?? '',
            displayName: topCommentDisplayName,
            mode: isEditor ? 'edit' : 'view',
            hasMediaUploadPermissions: hasMediaUploadPermissions,
            getInlineNodeTypes: getInlineNodeTypes,
            commentType: (0, $8i27m.CommentType).INLINE,
            isStandaloneComment: true
        });
        else {
            const getDeleteFn = ()=>{
                if (!isLivePage && isEditor) return undefined;
                return handleDeleteComment(undefined);
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kEmgx.CommentBody), {
                userId: topCommentUserId,
                avatarUrl: topCommentUserAvatar,
                displayName: topCommentDisplayName,
                date: when ?? '',
                dateUrl: commentUrl ?? '',
                createdAtNonLocalized: createdAtNonLocalized ?? '',
                versionDate: when ?? '',
                versionByDisplayName: versionByDisplayName,
                pageId: pageId,
                pageType: pageType,
                commentId: commentId ?? '',
                isReply: false,
                isEdited: isEdited,
                permissions: permissions,
                deleteComment: getDeleteFn,
                editComment: ()=>toggleCommentMode(commentId),
                content: content ?? '',
                isCommentActive: true,
                mode: isEditor ? 'edit' : 'view',
                onClose: onClose,
                permissionType: permissionType ?? undefined,
                resolveComment: handleResolveComment,
                supportedActions: supportedTopLevelActions,
                isUnread: currentUnreadIds.has(commentId ?? ''),
                numReplies: numReplies,
                unreadCommentRef: matchingRef,
                commentType: (0, $8i27m.CommentType).INLINE,
                inheritedReactionsData: reactionsSummary,
                reactionsCacheUpdateFn: updateReactionsCacheFn,
                isStandalonehovered: isStandalonehovered,
                isHovered: hoveredCommentId === commentId,
                replyToComment: handleReplyToComment,
                hideBranchingStyle: commentData?.replies.length === 0,
                resolveProperties: resolveProperties,
                isStandaloneComment: true,
                isOffline: isOffline
            }), !(0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $c7FK0.ReopenedMessage), {
                resolvedUser: resolvedUser ?? undefined,
                resolvedTime: resolvedTime
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $b8XTE.PageSegmentLoadEnd), {
                key: `stop-${commentId}`,
                metric: RENDER_METRIC
            }));
        }
    };
    annotationElementRef.current = document.getElementById(selectedAnnotation.id);
    // Handle case where comment has been deleted
    if (!annotationElementRef.current) return null;
    const isCommentAuthor = topCommentUserId === currentUserId;
    const isFirstComment = commentThreadLength === 1;
    // this is needed for longer comment threads to be scrollable
    // comment thread container should be scrollable if the height of the comment sidebar becomes
    // near greater than the max comment sidebar viewport height specified in inline-comments-common/src/styled-components.tsx
    const shouldMakeContainerScrollable = // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    (sidebarEl?.current?.getBoundingClientRect()?.height ?? 0) > window.innerHeight * 0.79 && (0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment') && (0, $9wGTI.fg)('confluence_frontend_comment_sidebar_max_height');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $B3Avz.CommentSidebar), {
        nudgeRef: nudgeRef,
        pageId: pageId,
        annotationElement: annotationElementRef.current,
        navigationOptions: navigationOptions,
        onClose: isEditor ? handleOnClose : onClose,
        isEditor: isEditor,
        isViewCommentMode: true,
        sidebarOffset: sidebarOffset,
        commentId: commentId,
        scrollIntoView: // Scrolling is handled separately for focused comment and unread comments
        // hence we should opt out scroll into view
        !focusedCommentId && !currentUnreadIds.size,
        isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar,
        sidebarEl: sidebarEl,
        annotationId: selectedAnnotation?.id,
        inlineCommentRef: inlineCommentRef,
        isSticky: isSticky
    }, markCommentReadError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: markCommentReadError
    }), resolvedComment && resolvedComment.commentId === commentData?.id ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9EgR7.ResolvedCommentNotification), {
        commentId: resolvedComment.commentId,
        reopenComment: handleReopen,
        pageId: pageId,
        inlineMarkerRef: resolvedComment.inlineMarkerRef,
        mode: "view"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: shouldMakeContainerScrollable && $f4f7ab8b4171ff8f$var$scrollableCommentSidebarStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        onMouseEnter: ()=>handleMouseEnter(commentId),
        onMouseLeave: handleMouseLeave
    }, renderComment()), !(0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment') && commentData?.replies && commentData?.replies.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $666Tc.ReplyListContainer), {
        "data-testid": "inline-comment-reply-container"
    }, shouldCollapseReplies && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8wupW.CollapsedReplies), {
        numCollapsedReplies: numReplies - 1,
        onClick: ()=>setIsReplyChainCollapsed(false)
    }), renderReplies(Boolean(shouldCollapseReplies))), commentData && (0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4Svbr.CommentReplies), {
        parentComment: (0, $3ZsvI.normalizeCommentData)({
            comment: commentData,
            readCommentsListState: readCommentsListState,
            currentUserId: currentUserId ?? '',
            pageMode: pageMode,
            isOpen: true,
            type: (0, $8i27m.CommentType).INLINE
        }),
        pageInfo: pageInfo,
        pageMode: pageMode,
        parentCommentId: commentData.id,
        handleMouseEnter: handleMouseEnter,
        handleMouseLeave: handleMouseLeave,
        canAddComments: canAddComments,
        isCurrentSelectedComment: false,
        hoveredCommentId: hoveredCommentId ?? '',
        isStandaloneComment: true,
        editCommentQueryId: editCommentQueryId,
        selectedAnnotation: selectedAnnotation,
        key: `standalone-comment-replies-${commentData.id}`,
        deleteStandaloneComment: handleDeleteComment,
        replyToComment: handleReplyToComment,
        updateReactionsCacheFn: updateReactionsCacheFn
    })), !isArchived && canAddComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $666Tc.NewReplyContainer), {
        mode: isEditor ? 'edit' : 'view',
        "data-cy": "editor-reply-container",
        "data-testid": "inline-comment-new-reply-container",
        ref: commentContainerElementRef
    }, !(0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $daq5m.CommentAuthor), {
        commentMode: "reply",
        userId: currentUserId,
        size: "small",
        permissionType: permissionType ?? undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hXzKU.LazyCommentEditor), {
        pageId: pageId,
        pageType: pageType,
        onCancelComment: onCancelComment,
        content: (0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment') ? (0, $7qvmT.getAdfForQuickReplyMention)(replyToCommentUser) : undefined,
        appearance: "chromeless",
        EditorComponent: (0, $7EEGh.ChromelessEditor),
        onSaveComment: (0, $9wGTI.fg)('unified_create_comment_reply_function') ? handleCreateReplyUnified : handleCreateReply,
        onContentChange: onChange,
        onEditorReady: ()=>{
            experienceTracker.succeed({
                name: (0, $irVI7.REPLY_TO_INLINE_COMMENT_LOAD_EXPERIENCE)
            });
        },
        commentMode: "reply",
        commentType: isEditor ? 'edit-inline' : 'inline',
        spaceId: spaceId,
        showCancelButton: true,
        useNewWarningModal: true,
        hideWatchCheckbox: true,
        expandEditor: shouldFocusNewReply,
        pageMode: isEditor ? 'edit' : 'view',
        hasMediaUploadPermissions: hasMediaUploadPermissions,
        shouldDisplayCommentReplyPrompts: shouldDisplayCommentReplyPrompts,
        topLevelCommentId: commentId,
        shouldWarnOnInternalNavigation: true,
        commentThreadLength: commentThreadLength,
        commentContainerElementRef: commentContainerElementRef,
        isStandaloneComment: (0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment'),
        ...(0, $9wGTI.fg)('confluence_frontend_comments_inline_apollo_loading') && {
            // Needed to remount this component when we change which comment we're viewing
            key: `comment-editor-${commentId}`
        },
        isOffline: isOffline
    }))), isCommentAuthor && isFirstComment && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $g1WP0.AsyncWrapper), {
        trigger: "inline-comments",
        showImage: false,
        width: 280,
        reference: nudgeRef
    }));
};
const $f4f7ab8b4171ff8f$export$183403b138e102b9 = (0, $7aRa9.withFlags)($f4f7ab8b4171ff8f$var$InlineCommentComponent);

});
parcelRegister("2qqNV", function(module, exports) {

$parcel$export(module.exports, "useShouldDisplayCommentReplyPrompts", () => $e09d402cfd85f393$export$edad5dc2490175a0);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $diswb = parcelRequire("diswb");

var $7W8i8 = parcelRequire("7W8i8");

var $7Sm4c = parcelRequire("7Sm4c");

var $7d8pR = parcelRequire("7d8pR");
const $e09d402cfd85f393$var$useShouldDisplayCommentReplyPromptsContentContributorsQuery = (0, $d2LG0.default)`query useShouldDisplayCommentReplyPromptsContentContributorsQuery($contentId:ID!){contentContributors(id:$contentId){isCurrentUserContributor}}`;
const $e09d402cfd85f393$var$useShouldDisplayCommentReplyPromptsWatchPageQuery = (0, $d2LG0.default)`query useShouldDisplayCommentReplyPromptsWatchPageQuery($contentId:ID!){content(id:$contentId){nodes{id currentUserIsWatching}}}`;
const $e09d402cfd85f393$var$logger = (0, $7W8i8.getLogger)('comment-reply-prompts');
const $e09d402cfd85f393$export$edad5dc2490175a0 = ({ contentId: contentId, commentData: commentData, userId: userId })=>{
    const isCommentReplyPromptsEligible = (0, $7d8pR.useGetCommentReplyPromptsEligibility)({
        contentId: contentId
    });
    const { data: contributorsData, error: contributorsDataError } = (0, $diswb.useQuery)($e09d402cfd85f393$var$useShouldDisplayCommentReplyPromptsContentContributorsQuery, {
        skip: !isCommentReplyPromptsEligible,
        fetchPolicy: 'cache-first',
        variables: {
            contentId: contentId
        }
    });
    const { data: watchData, error: watchDataError } = (0, $diswb.useQuery)($e09d402cfd85f393$var$useShouldDisplayCommentReplyPromptsWatchPageQuery, {
        skip: !isCommentReplyPromptsEligible,
        fetchPolicy: 'cache-first',
        variables: {
            contentId: contentId
        }
    });
    if (contributorsDataError) {
        $e09d402cfd85f393$var$logger.error`Error fetching ContentContributorsQuery, ${contributorsDataError}`;
        (0, $7Sm4c.markErrorAsHandled)(contributorsDataError);
    }
    if (watchDataError) {
        $e09d402cfd85f393$var$logger.error`Error fetching WatchPageQuery, ${watchDataError}`;
        (0, $7Sm4c.markErrorAsHandled)(watchDataError);
    }
    const shouldDisplayCommentReplyPrompts = (0, $gwFzn.useMemo)(()=>{
        if (!isCommentReplyPromptsEligible) return false;
        // if we both queries fail, we can't tell if the user is a watcher or contributor and we should not show the prompts
        if (watchDataError && contributorsDataError) return false;
        const isCurrentUserContributor = contributorsData?.contentContributors?.isCurrentUserContributor || false;
        const isUserWatchingPage = watchData?.content?.nodes?.[0]?.currentUserIsWatching || false;
        const replies = commentData?.replies || [];
        const topLevelAuthor = commentData?.author;
        const lastReplyAuthor = replies?.[replies?.length - 1]?.author;
        const lastAuthorInThread = lastReplyAuthor || topLevelAuthor;
        // if the last author in the thread is anonymous, we should not show the prompts
        if (!lastAuthorInThread?.accountId) return false;
        const userIsNotLastCommenterInThread = lastAuthorInThread.accountId !== userId;
        return userIsNotLastCommenterInThread && (isCurrentUserContributor || isUserWatchingPage);
    }, [
        commentData,
        contributorsData,
        contributorsDataError,
        isCommentReplyPromptsEligible,
        userId,
        watchData,
        watchDataError
    ]);
    return shouldDisplayCommentReplyPrompts;
};

});
parcelRegister("7d8pR", function(module, exports) {

$parcel$export(module.exports, "useGetCommentReplyPromptsEligibility", () => $71aa8ddf09c389e5$export$f05428d49259034e);

var $6mKj3 = parcelRequire("6mKj3");

var $7mpOv = parcelRequire("7mpOv");
const $71aa8ddf09c389e5$export$f05428d49259034e = ({ contentId: contentId })=>{
    const { isAIEnabledForContent: isAIEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    return isAIEnabledForContent && (0, $6mKj3.expValEquals)('cc_suggested_inline_comment_replies', 'cohort', 'test');
};

});


parcelRegister("a3q17", function(module, exports) {

$parcel$export(module.exports, "EDITOR_INLINE_COMMENT_RENDER_METRIC", () => $60a54f1e533f2ef6$export$52ff686bd4414bc5);
$parcel$export(module.exports, "RENDERER_INLINE_COMMENT_RENDER_METRIC", () => $60a54f1e533f2ef6$export$ac7f79e65475cee7);
$parcel$export(module.exports, "FABRIC_COMMENTS_HIGHLIGHTS_METRIC", () => $60a54f1e533f2ef6$export$321e1f68b293bf76);

var $lSOAM = parcelRequire("lSOAM");
var $jX1qB = parcelRequire("jX1qB");
const $60a54f1e533f2ef6$export$52ff686bd4414bc5 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.EDITOR_INLINE_COMMENT_RENDER_SEGMENT_KEY)
});
const $60a54f1e533f2ef6$export$ac7f79e65475cee7 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.RENDERER_INLINE_COMMENT_RENDER_SEGMENT_KEY)
});
const $60a54f1e533f2ef6$export$321e1f68b293bf76 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY),
    timings: [
        {
            key: 'fmp',
            endMark: 'fmp'
        },
        {
            key: 'tti',
            endMark: 'tti'
        },
        {
            key: 'highlightsRendered',
            endMark: 'highlightsRendered'
        }
    ]
});

});



//# sourceMappingURL=PageContentRendererFabric.2943bf11.js.map
